import { render, staticRenderFns } from "./UnknownCodesErrorCard.vue?vue&type=template&id=997977a8"
import script from "./UnknownCodesErrorCard.vue?vue&type=script&lang=js"
export * from "./UnknownCodesErrorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports